/* Toggles .is-stuck on the sticky header so it can shrink and gain a shadow.
   A plain rAF-throttled scroll check: the earlier sentinel + IntersectionObserver
   reported "stuck" at scroll 0, because an absolutely-positioned sentinel
   resolves against the nearest positioned ancestor, not the header. */
(function () {
  'use strict';

  function init() {
    var head = document.querySelector('.n-head');
    if (!head || head.dataset.stickyReady === '1') return;
    head.dataset.stickyReady = '1';

    var ticking = false;

    function update() {
      head.classList.toggle('is-stuck', window.scrollY > 8);
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });

    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
